import {
  AppConnectionIcon,
  ConnectStoreIcon,
} from "../../../../../assets/svgIcons";
import primaryComponents from "../../../../primaryComponents";
import { useChowdeckStoreConnect } from "./useChowdeckStoreConnect";
import { useValidation } from "./useValidation";
import secondaryComponents from "../../..";
import globalStyles from "../../../../../assets/styles/base/globalPage.module.scss";
import { convertToTilteCase } from "../../../../../helpers";
import { PRICE_RECORDING_OPTIONS } from "../../../../../helpers/constants";

export const ChowdeckStoreConnect = ({
  isEditMode = false,
  providerKey = "chowdeck",
  lumi_store_name,
  chowdeck_store_name,
}) => {
  const {
    storeList,
    formData,
    chowdeckStores,
    isLoading,
    isConnecting,
    mapping_id,
    setFormData,
    handleStoreConnection,
  } = useChowdeckStoreConnect({ providerKey });

  const {
    control,
    formState: { errors },
    handleSubmit,
  } = useValidation({ ...formData });

  const selectedPriceRecordingOption = PRICE_RECORDING_OPTIONS.find(
    (option) => option.value === formData?.price_recording_option,
  );

  return (
    <form
      onSubmit={handleSubmit(handleStoreConnection)}
      className={`${globalStyles["cardWithBorder"]}`}
    >
      <secondaryComponents.LoaderHelper
        classNames={"mt-5"}
        isLoading={isLoading}
      >
        <div
          className="d-flex flex-column flex-md-row align-items-start"
          style={{ columnGap: "40px", rowGap: "10px" }}
        >
          <div className="w-100">
            <primaryComponents.SelectFieldV2
              control={control}
              name="marketplace_store_ref"
              sideLabel={convertToTilteCase(providerKey)}
              value={
                chowdeck_store_name ||
                `Select a ${convertToTilteCase(providerKey)} store`
              }
              options={chowdeckStores}
              nameKey="name"
              idKey="reference"
              onChange={(value, label) => {
                setFormData((prev) => ({
                  ...prev,
                  marketplace_store_ref: value,
                  marketplace_store_name: label,
                }));
              }}
              errorMessage={errors?.marketplace_store_ref}
              isDisabled={isEditMode || mapping_id}
            />
          </div>

          <div className="mt-0 mt-md-3">
            <ConnectStoreIcon />
          </div>

          <div className="w-100">
            <primaryComponents.SelectFieldV2
              control={control}
              name="lumi_store_id"
              sideLabel="Lumi Business"
              options={storeList}
              value={lumi_store_name || "Select a Lumi Business store"}
              nameKey="name"
              idKey="id"
              onChange={(value) => {
                setFormData((prev) => ({ ...prev, lumi_store_id: value }));
              }}
              errorMessage={errors?.lumi_store_id}
              isDisabled={isEditMode || mapping_id}
            />
          </div>
        </div>

        <div className="w-100 mt-3">
          <primaryComponents.SelectField
            label="Record Order Price As"
            value={
              selectedPriceRecordingOption?.label || "Provider's total price"
            }
            options={PRICE_RECORDING_OPTIONS}
            nameKey="label"
            idKey="value"
            floatError={false}
            onChange={(value) => {
              setFormData((prev) => ({
                ...prev,
                price_recording_option: value,
              }));
            }}
            isDisabled={isEditMode || mapping_id}
          />
          {selectedPriceRecordingOption ? (
            <p className="small-text-size grey--text mt-2 mb-0">
              {selectedPriceRecordingOption.description}
            </p>
          ) : null}
        </div>

        <primaryComponents.Button
          classNames="btn btn--success mx-auto mt-3"
          style={{ width: "200px" }}
          type="submit"
          isLoading={isConnecting}
          isDisabled={isEditMode || isConnecting || mapping_id}
          loadingText={"Connecting..."}
        >
          <AppConnectionIcon className="mr-2" /> Connect
        </primaryComponents.Button>
      </secondaryComponents.LoaderHelper>
    </form>
  );
};
